if (!customElements.get('pp-gift-action')) {
  customElements.define('pp-gift-action', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const params = new URLSearchParams(window.location.search);
      const test = this.dataset.testMode === 'true';
      const preview = window.Shopify?.designMode || window.Shopify?.visualPreviewMode || params.has('preview_theme_id') || params.get('gift_test') === '1' || !!document.getElementById('preview-bar-iframe');
      const active = this.dataset.actionEnabled === 'true' && (!test || preview);
      this.querySelector('[data-ppap-active]').hidden = !active;
      this.querySelector('[data-ppap-empty]').hidden = active;
      const note = this.querySelector('[data-ppap-preview]');
      if (note) note.hidden = !(test && preview);
      const schedule = () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.refresh(), 180);
      };
      document.addEventListener('cart:updated', schedule, { signal: this.controller.signal });
      window.addEventListener('pageshow', event => { if (event.persisted) schedule(); }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.request?.abort();
    }
    async refresh() {
      this.request?.abort();
      this.request = new AbortController();
      const request = this.request;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { signal: request.signal, cache: 'no-store' });
        if (!response.ok) return;
        const html = await response.text();
        if (!this.isConnected || request.signal.aborted) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const next = parsed.querySelector('[data-ppap-status]');
        const current = this.querySelector('[data-ppap-status]');
        if (!next || !current) return;
        const focused = current.contains(document.activeElement);
        current.innerHTML = next.innerHTML;
        if (focused) current.querySelector('a')?.focus({ preventScroll: true });
      } catch (error) {
        if (error.name !== 'AbortError') this.dataset.refreshFailed = 'true';
      }
    }
  });
}
